Jelly.Actions.Add_Guest = function(Parameters) {
	var $Table_Wrapper = $("#" + Parameters.Namespace.Action + "_Add_Guest_Table_Wrapper");
	var $Table = $Table_Wrapper.find("table");
	var $Body = $Table.find("tbody");
	var Guest_Count = $Table.find("tbody tr").length + 1;

	if (!$Body.length) {
		$Body = $("<tbody/>").appendTo($Table);
	}

	var $Row = $("<tr/>");
	$Row.append($("<td/>").text(Parameters.Guest.Name));
	$Row.append($("<td/>").text(Parameters.Guest.Email));
	$Row.append($("<td/>").text(Parameters.Guest.Quantity));
	$Body.append($Row);
	$Table_Wrapper.show();

	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_Count",
		Value: Guest_Count
	});
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_" + Guest_Count + "_Name",
		Value: Parameters.Guest.Name
	});
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_" + Guest_Count + "_First_Name",
		Value: Parameters.Guest.First_Name || ""
	});
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_" + Guest_Count + "_Last_Name",
		Value: Parameters.Guest.Last_Name || ""
	});
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_" + Guest_Count + "_Email",
		Value: Parameters.Guest.Email
	});
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: "Add_Guest_" + Guest_Count + "_Quantity",
		Value: Parameters.Guest.Quantity
	});
};

Jelly.Actions.Add_Guests = function(Parameters) {
	if (!Array.isArray(Parameters.Guests) || !Parameters.Guests.length) {
		throw new Error("The file does not contain any guest rows.");
	}

	var normalizeHeader = function(Value) {
		return String(Value == null ? "" : Value).trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
	};
	var toString = function(Value) {
		return String(Value == null ? "" : Value).trim();
	};
	var normalizeName = function(Record) {
		Record.Name = toString(Record.Name);
		Record.First_Name = toString(Record.First_Name);
		Record.Last_Name = toString(Record.Last_Name);
		if (!Record.Name) {
			Record.Name = [Record.First_Name, Record.Last_Name].filter(Boolean).join(" ");
		}
		return Record;
	};
	var Guests = Parameters.Guests;
	var Records = [];

	if (Array.isArray(Guests[0])) {
		var Header = Guests[0].map(normalizeHeader);
		var Header_Count = Header.length;
		var Columns = {
			Name: Header.findIndex(function(Value) { return ["name", "guestname", "fullname"].indexOf(Value) !== -1; }),
			First_Name: Header.findIndex(function(Value) { return ["first", "firstname", "givenname"].indexOf(Value) !== -1; }),
			Last_Name: Header.findIndex(function(Value) { return ["last", "lastname", "surname", "familyname"].indexOf(Value) !== -1; }),
			Email: Header.findIndex(function(Value) { return ["email", "emailaddress"].indexOf(Value) !== -1; }),
			Quantity: Header.findIndex(function(Value) { return ["quantity", "qty", "ticketquantity", "tickets"].indexOf(Value) !== -1; })
		};
		if ((Columns.Name < 0 && (Columns.First_Name < 0 || Columns.Last_Name < 0)) || Columns.Quantity < 0) {
			throw new Error("Map Full name, or both First name and Last name, plus Quantity before importing.");
		}
		Guests.slice(1).forEach(function(Row, Index) {
			if (!Array.isArray(Row) || Row.length !== Header_Count) {
				throw new Error("Row " + (Index + 2) + " has a different number of columns than the header. Fix that row and upload the file again.");
			}
			Records.push(normalizeName({
				Name: Columns.Name < 0 ? "" : toString(Row[Columns.Name]),
				First_Name: Columns.First_Name < 0 ? "" : toString(Row[Columns.First_Name]),
				Last_Name: Columns.Last_Name < 0 ? "" : toString(Row[Columns.Last_Name]),
				Email: Columns.Email < 0 ? "" : toString(Row[Columns.Email]),
				Quantity: toString(Row[Columns.Quantity])
			}));
		});
	}
	else {
		Records = Guests.map(function(Guest) {
			return normalizeName({
				Name: toString(Guest.Name),
				First_Name: toString(Guest.First_Name),
				Last_Name: toString(Guest.Last_Name),
				Email: toString(Guest.Email),
				Quantity: toString(Guest.Quantity)
			});
		});
	}

	var Seen_Emails = {};
	Records.forEach(function(Guest, Index) {
		var Validation_Error = ((Guest.First_Name && !Guest.Last_Name) || (!Guest.First_Name && Guest.Last_Name)) ?
			"Map both First name and Last name, or use Full name." : Jelly.Actions.Validate_Guest({
			Name: Guest.Name,
			Email: Guest.Email,
			Quantity: Guest.Quantity,
			Namespace: Parameters.Namespace,
			Skip_Table_Duplicate_Check: true
		});
		var Normalized_Email = Guest.Email.toLowerCase();
		if (!Validation_Error && Normalized_Email && Seen_Emails[Normalized_Email]) {
			Validation_Error = "This email address appears twice in this file. Please use one row per person.";
		}
		if (Validation_Error) {
			throw new Error("Row " + (Index + 2) + ": " + Validation_Error + " No guests were added.");
		}
		if (Normalized_Email) {
			Seen_Emails[Normalized_Email] = true;
		}
	});

	Jelly.Actions.Clear_Guests(Parameters);

	Records.forEach(function(Guest) {
		Jelly.Actions.Add_Guest({
			Namespace: Parameters.Namespace,
			Guest: Guest
		});
	});
};

Jelly.Actions.Clear_Guests = function(Parameters) {
	var $Action = $("#" + Parameters.Namespace.Action);
	var Action_Element = $Action.get(0);
	var Action_Reference = Action_Element ? Jelly.References.Get_Reference_For_Element(Action_Element) : null;
	if (Action_Reference && Action_Reference.Inputs) {
		Object.keys(Action_Reference.Inputs).forEach(function(Input_Alias) {
			if (/^Add_Guest_/i.test(Input_Alias)) {
				Jelly.Actions.Remove_Action_Input({
					Namespace: Parameters.Namespace.Action,
					Alias: Input_Alias,
					Element: Action_Reference.Inputs[Input_Alias].Element
				});
			}
		});
	}
	// Remove any matching orphan inputs that predate action-input registration.
	$Action.find("input").filter(function() {
		return /^Add_Guest_/i.test(this.name || "");
	}).remove();
	var $Table_Wrapper = $("#" + Parameters.Namespace.Action + "_Add_Guest_Table_Wrapper");
	$Table_Wrapper.find("tbody").remove();
	$Table_Wrapper.hide();
};

Jelly.Actions.Validate_Guest = function(Parameters) {
	var Email_Validator = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i;
	var Quantity = String(Parameters.Quantity == null ? "" : Parameters.Quantity).trim();

	if (!String(Parameters.Name == null ? "" : Parameters.Name).trim()) {
		return "Please enter a name.";
	}
	if (!/^[1-9][0-9]*$/.test(Quantity)) {
		return "Please enter a whole-number quantity of at least 1.";
	}
	if (Parameters.Email && !Email_Validator.test(String(Parameters.Email).trim())) {
		return "Please enter a valid email address.";
	}

	if (Parameters.Email && !Parameters.Skip_Table_Duplicate_Check) {
		var Normalized_Email = String(Parameters.Email).trim().toLowerCase();
		var Email_Is_Unique = true;
		var $Table_Wrapper = $("#" + Parameters.Namespace.Action + "_Add_Guest_Table_Wrapper");
		$Table_Wrapper.find("tbody tr").each(function(Row_Index, Row) {
			if (Normalized_Email === $(Row).find("td:eq(1)").text().trim().toLowerCase()) {
				Email_Is_Unique = false;
				return false;
			}
		});
		if (!Email_Is_Unique) {
			return "You've already entered this email address.";
		}
	}
};
